// Pure helpers voor de offerteteksten-bibliotheek (geen netwerk, makkelijk te testen).

import type { ContentBlock } from './types';

/** Volgorde + NL-labels van de blok-soorten in de bibliotheek-UI. */
export const BLOCK_KINDS: { kind: ContentBlock['kind']; label: string }[] = [
  { kind: 'goed_doel', label: 'Goede doelen' },
  { kind: 'partner', label: 'Partners' },
  { kind: 'logistiek', label: 'Logistiek' },
  { kind: 'overig', label: 'Overig' },
];

const KIND_LABEL: Record<ContentBlock['kind'], string> = {
  goed_doel: 'Goed doel',
  partner: 'Partner',
  logistiek: 'Logistiek',
  overig: 'Overig',
};

/** Losse (enkelvoud) NL-label voor een blok-soort, bv. voor een select-optie. */
export function kindLabel(kind: ContentBlock['kind']): string {
  return KIND_LABEL[kind];
}

/**
 * Groepeert blokken per soort, in de vaste volgorde van BLOCK_KINDS.
 * Lege groepen blijven aanwezig zodat de UI altijd alle koppen toont.
 */
export function groupBlocksByKind(
  blocks: ContentBlock[]
): { kind: ContentBlock['kind']; label: string; blocks: ContentBlock[] }[] {
  return BLOCK_KINDS.map(({ kind, label }) => ({
    kind,
    label,
    blocks: blocks.filter((b) => b.kind === kind),
  }));
}

/**
 * Parset een tags-invoer (komma-gescheiden tekst) naar een schone string-array.
 * Lege waarden vallen weg, dubbele spaties worden getrimd. Geen tags = null.
 */
export function parseTags(input: string): string[] | undefined {
  const tags = input
    .split(',')
    .map((t) => t.trim())
    .filter(Boolean);
  return tags.length > 0 ? tags : undefined;
}

/**
 * Bouwt een titel voor een huisstijl-voorbeeld uit klant/project + thema.
 * Bv. "OVO Fryslan-Noord 2026 - Duurzaam kerstpakket".
 */
export function buildExampleTitle(
  parts: { projectName?: string | null; clientName?: string | null; theme?: string | null }
): string {
  const head = (parts.clientName || parts.projectName || 'Voorbeeld').trim();
  const theme = (parts.theme ?? '').trim();
  return theme ? `${head} - ${theme}` : head;
}
